import { Component, Input, OnChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { retirement_date_form_keys, retirement_date_form_template, retirement_date_form_validators } from './retirement-date-variation.constants';
import moment = require('moment');
import { FormUtils } from 'src/app/utils/FormUtils';

@Component({
  selector: 'app-retirement-date-variation',
  templateUrl: './retirement-date-variation.component.html',
  styleUrl: './retirement-date-variation.component.scss'
})
export class RetirementDateVariationComponent implements OnChanges {
  @Input() form: FormGroup;
  @Input() currentRetirementDate: string;


  public keys: IFormKey[] = CommonUtils.assign(retirement_date_form_keys)
  ngOnChanges(): void {
    
    FormUtils.disableFormFields(this.form, ['variationDate', 'currentRetirementDate']);
    FormUtils.enableFormFields(this.form, ['newRetirementDate']);
    FormUtils.patchFormFromObject(
      {
        variationDate: moment().format('YYYY-MM-DD'),
        currentRetirementDate: this.currentRetirementDate,
        newRetirementDate: null
      },
      this.form
    );
  }
}
